import Tabs from "../tabs";
import pretty from "../prettier";
import resolveMode from "./resolveMode";
import ImageHelpersTemplate from "../../templates/imageHelper.svelte";
import { addTrail } from "../trail";
/**
 * Loads an ixcanul file from the database using the LoadFile backend API
 * @param {Object} node an object representing a node on the file tree or the required fields in the save api
 * @param {String} fileType the file type.
 * @param {String} path the path for the file which you need to load
 * @param {Function} callback a callback function, runs after the file had finished loading.
 * @param {Boolean} passive load files silently without changes to the UI.
 * @return {Boolean}
 */

export default (node, fileType, path, callback, passive) => {
  let fileData;
  if (typeof node.data.image_url !== "undefined") {
    if (!passive) {
      const imagePath = window.location.origin + node.data.image_url;
      Tabs.addImageView(node.title, node.key, path);
      let [imageViewer] = Panes.root.getItemsById(path)[0].element.find(".image-viewer");
      let transformedURL = new URL(imagePath);
      let imageURL = location.origin + transformedURL.pathname + transformedURL.search;
      new ImageHelpersTemplate({
        target: imageViewer,
        props: {
          imageViewer,
          imageURL
        }
      });
      addTrail(`Opened image "${node.title}"`);
    }
    typeof callback === "function" && callback(node, CodeEditor.Main.convertFileToDataURL(node.data.image_url));
  } else {
    let extension = node.title.split(".").pop();
    console.log("the ex", extension);
    let url =
      CodeEditor.Main.mode(node) === "tephra"
        ? "/api/v1/tephra_snippets/" + node.data.secure_random
        : "/api/v1/code_editor/" + node.data.secure_random;
    if (passive !== true) {
      // const mode = node.title.split(".")[node.title.split(".").length - 1];
      Tabs.add(node.title, path, fileType, node.key, node);
      Tabs.getTabByKey(node.key).element.addClass("loading_file");
      ga("send", "event", "Open file");
      addTrail(`Opened "${node.title}"`);
    }

    return $.ajax({
      headers: {
        "x-csrf-token": $("meta[name='csrf-token']").attr("content")
      },
      type: "get",
      url: url,
      data: {
        extension: extension,
        file_type: node.data.file_type,
        theme_id: CodeEditor.Main.themeId(),
        socket_id: window.socketId
      },

      success: async function(data) {
        fileData = data;

        if (passive === true) {
          fileData = data;
          return fileData;
        }
        if (!Tabs.getTabByKey(node.key)) {
          return true;
        }
        CodeEditor.bindChannels.triggerEvent({
          eventName: "file-online",
          data: {
            name: "hodor"
          }
        });
        Tabs.getTabByKey(node.key).element.removeClass("loading_file");
        tree.getNodeByKey(String(node.key)).data.content = fileData;
        tree.getNodeByKey(String(node.key)).data.variations_attributes = data.variations_attributes;
        tree.getNodeByKey(String(node.key)).data.tephra_snippet_id = data.tephra_snippet_id;
        window.editor.focus();
        aceSessions["session_" + node.key] = ace.createEditSession(fileData, "ace/mode/text");
        window.editor.setSession(aceSessions["session_" + node.key]);
        window.editor.session.getUndoManager().markClean();
        window.editor.session.setOptions({
          wrap: "free"
        });
        window.editor.getSession().setUndoManager(new ace.UndoManager());
        window.editor.clearSelection();
        window.editor.getSession().setMode("ace/mode/text");
        resolveMode(extension);
        Tabs.setActiveById(path);
        if (path.includes("settings.json")) {
          let json = JSON.parse(editor.getValue());
          const requiredKeys = ["scope", "options", "allow_duplicates", "tags"];
          const hasAllReqKeys = requiredKeys.every(key => Object.prototype.hasOwnProperty.call(json, key));
          if (!hasAllReqKeys) {
            json = {
              scope: json.scope || false,
              allow_duplicates: json.allow_duplicates || true,
              options: json.options || {},
              tags: json.tags || [],
              ...json
            };
            editor.setValue(JSON.stringify(json, null, "\t"), -1);
          }
          pretty("json", window.editor.session, null);
          window.editor.getSession().setUndoManager(new ace.UndoManager());
        }
      }
    }).then(data => typeof callback === "function" && callback(node, data));
  }
};
